import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import LensAdminReports from "../../routes/lenses/lens/admin/LensAdminReports";

export default function ReportsHome() {
  const navigate = useNavigate();
  const params = useParams();

  if (!params.lensId) {
    navigate("../");
    return null;
  }

  const lensId = parseInt(params.lensId || "");
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: "100%",
        minWidth: 0,
      }}>
      <LensAdminReports lensId={lensId} />
    </Box>
  );
}
